<div
        #modal
        class="backdrop"
        [ngClass]="{
            'opened': isModalOpened
        }"
        id="{{ id }}"
        (click)="closeModal()"
>
    <div class="ui-modal" role="document" (click)="$event.stopPropagation()">
        @let _contentHeight = contentHeight;
        @let _contentWidth = contentWidth;

        <button
            type="button"
            class="ui-modal__close-button"
            aria-label="Close"
            (click)="closeModal()"
        >
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.41714 1.30571L8 6.88857L13.5829 1.30571C14.0278 0.860731 14.7493 0.860731 15.1943 1.30571C15.6393 1.7507 15.6393 2.47216 15.1943 2.91714L9.61143 8.5L15.1943 14.0829C15.6393 14.5278 15.6393 15.2493 15.1943 15.6943C14.7493 16.1393 14.0278 16.1393 13.5829 15.6943L8 10.1114L2.41714 15.6943C1.97216 16.1393 1.2507 16.1393 0.805714 15.6943C0.360731 15.2493 0.360731 14.5278 0.805714 14.0829L6.38857 8.5L0.805714 2.91714C0.360731 2.47216 0.36073 1.7507 0.805714 1.30571C1.2507 0.86073 1.97216 0.860731 2.41714 1.30571Z"
                      fill="currentColor"/>
            </svg>
        </button>

        <div #modalContent class="ui-modal__content"
             [style.height]="_contentHeight"
             [style.width]="_contentWidth"
        >
            <div class="ui-modal__header" #modalHeader>
                <ng-content select="[modalIcon]"></ng-content>
                <div class="title-wrapper {{ modalHeader?.children?.length === 1 ? 'centered-title' : '' }}">
                    <ng-content select="[modalTitle]"></ng-content>
                    <ng-content select="[modalSubtitle]"></ng-content>
                </div>
            </div>
            <div class="ui-modal__body-wrapper">
                <div class="ui-modal__body">
                    <ng-content select="[modalContent]"></ng-content>
                    <ng-content></ng-content>
                </div>
            </div>
            <div class="ui-modal__footer">
                <ng-content select="[modalClose]"></ng-content>
                <ng-content select="[modalAction]"></ng-content>
                <ng-content select="[modalConfirm]"></ng-content>
            </div>
        </div>
    </div>
</div>
